/* eslint-disable */
import React, { useState } from "react";
import { SmartImg } from "../utils";
import importStyles from "./CatalogModals.module.css";

// ── Item Detail Modal ──────────────────────────────────────────────────────────
// Moved to the New-DNA Frame Detail panel (Gallery Spotlight):
// src/components/originals/FrameDetailModal.js (+ FrameDetailStage / FrameDetailPanel).
// App.js mounts <FrameDetailModal> directly. CatalogModals.js retains the
// FullScreen / Import / HoverPreview modals only (split per Convention #6 — this
// file was over the 300-LOC cap before the extraction).

// ── Full Screen Gallery ───────────────────────────────────────────────────────
export function FullScreenGallery({ fullScreen, setFullScreen, fsImgIdx, setFsImgIdx, fsZoomed, setFsZoomed, setSelected }) {
  const fsImgs = (fullScreen.images||[]).length>0 ? fullScreen.images : (fullScreen.image ? [fullScreen.image] : []);
  const currentFsImg = fsImgs[fsImgIdx] || fsImgs[0];
  return (
    <div className={importStyles.fsGallery} style={{ position:"fixed", inset:0, zIndex:'var(--z-modal-stack)', background:"var(--card-bg)", display:"flex", flexDirection:"column", animation:"fadeIn .3s ease" }}
      onKeyDown={e=>{
        if (e.key==="Escape") { setFullScreen(null); setFsZoomed(false); }
        if (e.key==="ArrowRight"&&fsImgIdx<fsImgs.length-1) { setFsImgIdx(i=>i+1); setFsZoomed(false); }
        if (e.key==="ArrowLeft"&&fsImgIdx>0) { setFsImgIdx(i=>i-1); setFsZoomed(false); }
        if (e.key===" ") { e.preventDefault(); setFsZoomed(z=>!z); }
      }} tabIndex={0} ref={el=>el&&el.focus()}>
      <div style={{ height:48, padding:"0 var(--space-2xl)", display:"flex", alignItems:"center", justifyContent:"space-between", flexShrink:0 }}>
        <div onClick={()=>{setFullScreen(null);setFsZoomed(false);setSelected(fullScreen);}} style={{ fontSize:'var(--text-2xs)', letterSpacing:"2px", color:"var(--text)", textTransform:"uppercase", cursor:"pointer", transition:"color .15s" }}
          onMouseEnter={e=>e.currentTarget.style.color="var(--gold-deep)"}
          onMouseLeave={e=>e.currentTarget.style.color="var(--text)"}>
          ← BACK TO DETAIL
        </div>
        <div style={{ textAlign:"center" }}>
          <span style={{ fontSize:'var(--text-sm)', fontWeight:'var(--weight-bold)', color:"var(--text)" }}>{fullScreen.brand}</span>
          <span style={{ fontSize:'var(--text-xs)', color:"var(--sandstone)", marginLeft:'var(--space-sm)'}}>{fullScreen.sku||""}</span>
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:'var(--space-md)'}}>
          {fsImgs.length>1 && <>
            <svg onClick={()=>{if(fsImgIdx>0){setFsImgIdx(i=>i-1);setFsZoomed(false);}}} style={{ cursor:fsImgIdx>0?"pointer":"default", opacity:fsImgIdx>0?0.7:0.2 }} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--text)" strokeWidth="1.5"><path d="M15 18l-6-6 6-6"/></svg>
            <span style={{ fontSize:'var(--text-xs)', color:"var(--sandstone)" }}>{fsImgIdx+1} / {fsImgs.length}</span>
            <svg onClick={()=>{if(fsImgIdx<fsImgs.length-1){setFsImgIdx(i=>i+1);setFsZoomed(false);}}} style={{ cursor:fsImgIdx<fsImgs.length-1?"pointer":"default", opacity:fsImgIdx<fsImgs.length-1?0.7:0.2 }} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--text)" strokeWidth="1.5"><path d="M9 18l6-6-6-6"/></svg>
          </>}
          <button onClick={()=>{setFullScreen(null);setFsZoomed(false);}} style={{ background:"var(--card-bg)", border:"var(--border-thin) solid var(--text)", borderRadius:'var(--radius-md)', padding:"var(--space-sm) var(--space-lg)", cursor:"pointer", fontSize:'var(--text-2xs)', color:"var(--text)", textTransform:"uppercase", letterSpacing:"1px", transition:"border-color .15s" }}
            onMouseEnter={e=>e.currentTarget.style.borderColor="var(--gold-deep)"}
            onMouseLeave={e=>e.currentTarget.style.borderColor="var(--text)"}>ESC</button>
        </div>
      </div>
      <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:"var(--space-xl) 60px", overflow:"hidden" }}>
        {currentFsImg
          ?<img src={currentFsImg} alt="" loading="lazy" onClick={()=>setFsZoomed(z=>!z)}
            style={{ maxWidth:"100%", maxHeight:"100%", objectFit:"contain", transition:"transform .3s ease", transform:fsZoomed?"scale(2)":"scale(1)", cursor:fsZoomed?"zoom-out":"zoom-in" }}/>
          :<div style={{ fontSize:'var(--text-base)', color:"rgba(26,26,26,0.15)", fontWeight:'var(--weight-bold)', letterSpacing:"4px" }}>NO IMAGE</div>}
      </div>
      <div style={{ flexShrink:0, padding:"var(--space-lg) var(--space-2xl)", display:"flex", alignItems:"center", justifyContent:"space-between", borderTop:"var(--border-thin) solid rgba(26,26,26,0.08)" }}>
        <div style={{ display:"flex", gap:'var(--space-sm)'}}>
          {fsImgs.map((img,i)=>(
            <div key={i} onClick={()=>{setFsImgIdx(i);setFsZoomed(false);}}
              style={{ width:56, height:42, borderRadius:'var(--radius-sm)', border:i===fsImgIdx?"1px solid var(--gold)":"1px solid rgba(26,26,26,0.15)", overflow:"hidden", cursor:"pointer", transition:"border-color .15s ease" }}
              onMouseEnter={e=>{ if(i!==fsImgIdx) e.currentTarget.style.borderColor="var(--gold-deep)"; }}
              onMouseLeave={e=>{ if(i!==fsImgIdx) e.currentTarget.style.borderColor="rgba(26,26,26,0.15)"; }}>
              <img src={img} alt="" loading="lazy" style={{ width:"100%", height:"100%", objectFit:"contain" }}/>
            </div>
          ))}
        </div>
        <div style={{ fontSize:'var(--text-2xs)', color:"var(--sandstone)", letterSpacing:"1px" }}>
          {fullScreen.shape1&&<><span style={{ color:"var(--text)", fontWeight:'var(--weight-semi)' }}>{fullScreen.shape1}</span> · </>}
          {fullScreen.gender&&<><span style={{ color:"var(--text)", fontWeight:'var(--weight-semi)' }}>{fullScreen.gender}</span> · </>}
          {fullScreen.status&&<span style={{ color:"var(--text)", fontWeight:'var(--weight-semi)' }}>{fullScreen.status}</span>}
        </div>
      </div>
    </div>
  );
}

// ── Import Modal ──────────────────────────────────────────────────────────────
const IMP_ICON = <svg viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" /></svg>;
const IMP_X = <svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12" /></svg>;
const IMP_CHECK = <svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5" /></svg>;

export function ImportModal({ showImport, setShowImport, importPreview, setImportPreview, handleImportFile, handleImportConfirm, T, cardSt, btnP, btnS, br75 }) {
  const [dragOver, setDragOver] = useState(false);
  const onDrop = (e) => {
    e.preventDefault(); setDragOver(false);
    const file = e.dataTransfer?.files?.[0];
    if (file) handleImportFile({ target: { files: [file] } });
  };
  const close = () => { setShowImport(false); setImportPreview(null); };
  return (
    <div className={importStyles.dnaImport} onClick={e => e.target === e.currentTarget && setShowImport(false)}>
      <div className={importStyles.modal}>
        <div className={importStyles.head}>
          <span className={importStyles.headBadge}>{IMP_ICON}</span>
          <div className={importStyles.headText}>
            <div className={importStyles.title}>Import from Excel / CSV</div>
            <div className={importStyles.sub}>Bulk add or update originals</div>
          </div>
          <button className={importStyles.close} onClick={close} aria-label="Close">{IMP_X}</button>
        </div>

        {!importPreview ? (
          <>
            <div className={importStyles.body}>
              <div className={importStyles.structCard}>
                <div className={importStyles.structTitle}>File structure</div>
                <div className={importStyles.structText}>
                  First row must be column headers. Required: <strong>Model</strong>, <strong>Brand</strong>.
                </div>
                <div className={importStyles.reqChips}>
                  <span className={importStyles.reqChip}>Model</span>
                  <span className={importStyles.reqChip}>Brand</span>
                </div>
                <div className={importStyles.tip}>Tip — export your catalog first and use it as a template.</div>
              </div>
              <label
                className={importStyles.drop}
                onDragOver={e => { e.preventDefault(); setDragOver(true); }}
                onDragLeave={() => setDragOver(false)}
                onDrop={onDrop}
                style={dragOver ? { borderColor: "var(--amber-500)", background: "var(--amber-50)" } : undefined}
              >
                <span className={importStyles.dropIcon}>{IMP_ICON}</span>
                <span className={importStyles.dropTitle}>Click to select, or drag a file here</span>
                <span className={importStyles.dropHint}>JSON — import with images · CSV — without images</span>
                <span className={importStyles.fmtChips}>
                  <span className={importStyles.fmtChip}>.csv</span>
                  <span className={importStyles.fmtChip}>.json</span>
                </span>
                <input type="file" accept=".csv,.txt,.json" style={{ display: "none" }} onChange={handleImportFile} />
              </label>
              <div className={importStyles.footNote}>Nothing imports until you review.</div>
            </div>
            <div className={importStyles.foot}>
              <button className={importStyles.btnGhost} onClick={close}>Cancel</button>
            </div>
          </>
        ) : (
          <div className={importStyles.body}>
            <div className={importStyles.previewOk}>{IMP_CHECK} Found {importPreview.length} items ready to import</div>
            <div className={importStyles.previewList}>
              {importPreview.slice(0, 10).map((item, i) => (
                <div key={i} className={importStyles.previewRow}>
                  <span className={importStyles.previewModel}>{item.model}</span>
                  <span className={importStyles.previewMeta}>{item.brand} · {item.sku || "no SKU"}</span>
                </div>
              ))}
              {importPreview.length > 10 && <div className={importStyles.previewMore}>…and {importPreview.length - 10} more</div>}
            </div>
            <div className={importStyles.previewActions}>
              <button className={importStyles.btnPrimary} onClick={() => handleImportConfirm("merge")}>Add to existing</button>
              <button className={importStyles.btnDanger} onClick={() => handleImportConfirm("replace")}>Replace all</button>
            </div>
            <button className={importStyles.btnBack} onClick={() => setImportPreview(null)}>← Choose a different file</button>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Hover Preview ─────────────────────────────────────────────────────────────
export function HoverPreview({ hoverPreview }) {
  const imgs=(hoverPreview.item.images||[]).length>0?hoverPreview.item.images:(hoverPreview.item.image?[hoverPreview.item.image]:[]);
  if(!imgs.length) return null;
  const W=520,H=400,vw=window.innerWidth,vh=window.innerHeight;
  let left=hoverPreview.x-W/2,top=hoverPreview.y-H-14;
  if(left<8) left=8; if(left+W>vw-8) left=vw-W-8; if(top<8) top=hoverPreview.y+60;
  return (
    <div data-hide-on-touch data-hover-preview style={{ position:"fixed",left,top,width:W,height:H,zIndex:'var(--z-modal-stack)',pointerEvents:"none",borderRadius:0,overflow:"hidden",border:"var(--border-thick) solid #0a0a0a" }}>
      <SmartImg src={imgs[0]} displayWidth={520} alt="" style={{ width:"100%",height:"100%",objectFit:"contain",display:"block",background:"#f7f7f5" }}/>
      <div data-hp-caption style={{ position:"absolute",bottom:0,left:0,right:0,background:"rgba(0,0,0,0.65)",padding:"var(--space-md) var(--space-lg)"}}>
        <div style={{ color:"var(--card-bg)",fontSize:'var(--text-xs)',fontWeight:'var(--weight-bold)',letterSpacing:"0.1em",textTransform:"uppercase" }}>{hoverPreview.item.model}</div>
        <div style={{ color:"rgba(255,255,255,0.65)",fontSize:'var(--text-2xs)',marginTop:'var(--space-2xs)'}}>{hoverPreview.item.brand}</div>
      </div>
      {imgs.length>1&&<div data-hp-more style={{ position:"absolute",top:8,right:8,background:"rgba(0,0,0,0.55)",color:"var(--card-bg)",fontSize:'var(--text-2xs)',fontWeight:'var(--weight-bold)',padding:"var(--space-2xs) var(--space-sm)",borderRadius:'var(--radius-pill)' }}>+{imgs.length-1} more</div>}
    </div>
  );
}
